var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d2-container',[_c('template',{slot:"header"},[_vm._v(_vm._s(((_vm.$t('pub.pageHeader.demo')) + " 1")))]),_c('DemoI18nControl'),_c('DemoI18n')],2)}
var staticRenderFns = []

export { render, staticRenderFns }